import { NotificationService } from './services/notification.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { UserService, ApiService } from './services';
import { AuthService } from './services/auth.service';

import { LoaderInterceptor } from './interceptors/loader.interceptor';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { usernameValidatorDirective } from './validation/matchUsername.validator';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs-v2';

@NgModule({
  declarations: [usernameValidatorDirective],
  imports: [CommonModule, HttpClientModule, NgxLinkifyjsModule.forRoot()],
  providers: [
    UserService,
    ApiService,
    AuthService,
    NotificationService,
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
  ],
  exports: [usernameValidatorDirective],
})
export class CoreModule {}
